<section class="cotizar-page">
  <div class="cotizar-hero">
    <div class="hero-content">
      <h1>Cotiza online al instante</h1>
      <p>Selecciona una opción:</p>
    </div>
  </div>

  <div class="cotizar-opciones">
    <div class="opcion" *ngFor="let tipo of tipos; let i = index">
      <img
        [src]="
          i === 0
            ? 'assets/images/cotizar-particular.png'
            : 'assets/images/cotizar-logistica.png'
        "
        [alt]="tipo.titulo"
      />

      <a class="btn-cotizar" [routerLink]="tipo.url">
        {{ tipo.titulo }}
      </a>
    </div>
  </div>

  <div class="cotizar-info">
    <div class="info-imagen">
      <img
        src="assets/images/plataformaMonitoreo.png"
        alt="Plataforma de monitoreo Orbitec"
      />
    </div>

    <div class="info-texto">
      <h2>Gestión y tecnología satelital</h2>

      <p>
        Somos una empresa peruana especializada en la Gestión de Flota Vehicular
        y Telemetría. Desarrollamos productos personalizados, enfocados en cada
        una de las necesidades de control y gestión de nuestros clientes.
      </p>

      <a routerLink="/servicios/rastreoLogistico">Conoce más</a>
    </div>
  </div>
</section>
